import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <p>Cognitive trust is fragile, however, because it’s based on an
                                                understanding of skills and experience only. It is easy to
                                                damage by, say, missing a deadline or making a mistake in which
                                                case the sort of behaviour we mentioned at the start, of
                                                colleagues monitoring or duplicating each other’s work, becomes
                                                more likely.</p>
                                            <p><span className="subtiltereg">Transactional trust</span><br/>
                                            </p><p className="title-para" style={{paddingBottom:'40px'}}>Building
                                            transactional trust occurs through ‘psychological contracting’. The
                                            model below shows how this works.<a className="superscripttext"
                                                                                href="further_info.php?course=300"><sup>3</sup></a> It’s
                                            a process by which individuals in a group, who each have particular
                                            roles, tasks or requirements, agree ways of assisting and monitoring
                                            each other, and renegotiating ways of working together where
                                            necessary. In other words, it’s about the ways a group interacts and
                                            adapts as individual members’ needs arise, to ensure achievement of
                                            its overall objectives. In this way, the potential for uncertainty,
                                            lack of clarity and mistakes is reduced because the group’s members
                                            have a ‘psychological contract’ with each other to accommodate and
                                            manage such occurrences.</p>

                                            <div className="arrowimage">
                                                <div className="large-arrow"><img
                                                    src={require('@images/arrow_large.jpg')}
                                                    style={{height:'526px'}}/></div>
                                                <div className="separate">
                                                    <div className="lightgreencontentbg ilead-people-pad-cntrl">
                                                        <div className="border_subtitle">Informing</div>
                                                        <p>Each party informs the others of their needs and what
                                                            they are prepared to offer.</p></div>
                                                    <img
                                                        src={require('@images/arrow-small.jpg')}
                                                        style={{paddingLeft:'50%',width:'30px'}}/>
                                                        <div
                                                            className="lightgreencontentbg ilead-people-pad-cntrl"
                                                            style={{marginTop: '0px'}}>
                                                            <div className="border_subtitle">Negotiating</div>
                                                            <p>Each party agrees what they are prepared to do
                                                                for one another.</p></div>
                                                        <img
                                                            src={require('@images/arrow-small.jpg')}
                                                            style={{paddingLeft:'50%',width:'30px'}}/>
                                                            <div
                                                                className="lightgreencontentbg ilead-people-pad-cntrl"
                                                                style={{marginTop: '0px'}}>
                                                                <div className="border_subtitle">Monitoring
                                                                </div>
                                                                <p>Each party agrees to monitor one another to
                                                                    ensure the contract is kept and remains
                                                                    fair.</p></div>
                                                            <img
                                                                src={require('@images/arrow-small.jpg')}
                                                                style={{paddingLeft:'50%',width:'30px'}}/>
                                                                <div
                                                                    className="lightgreencontentbg ilead-people-pad-cntrl"
                                                                    style={{marginTop: '0px',marginBottom:'40px'}}>
                                                                    <div
                                                                        className="border_subtitle">Renegotiating
                                                                    </div>
                                                                    <p>Renegotiations occur on an ongoing basis,
                                                                        or if one party decides to exit the
                                                                        relationship.</p></div>


                                                </div>
                                            </div>

                                            <br/>

                                                <p><span className="subtiltereg">Affective trust</span></p>
                                                <p>This type of trust, also known as ‘emotional’ trust, takes
                                                    longer to achieve but is key to establishing deeper, longer
                                                    lasting relationships with others. It requires a greater
                                                    mutual understanding than is gained by knowledge of each
                                                    other’s abilities or through agreements made with them. The
                                                    way people establish affective trust is to develop
                                                    sufficient understanding of each other’s emotional and
                                                    social behaviour as to be able, generally, to predict how
                                                    they will behave in most situations.</p>
                                                <div className="paraspace"><p>Affective trust requires time
                                                    spent demonstrating:</p></div>

                                                <ul className="greenbullet-list people-list-pad">
                                                    <li>Empathy</li>
                                                    <li>Respect</li>
                                                    <li>Active listening</li>
                                                    <li>Interest in the other party (or parties).</li>
                                                </ul>
                                                <div className="paraspace"><p>It also depends on the kind of
                                                    non-verbal behaviour which communicates: </p></div>
                                                <ul className="greenbullet-list people-list-pad">
                                                    <li>Warmth</li>
                                                    <li>Attentiveness.</li>
                                                </ul>
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div onClick={this.props.handleChangePage('Page4')}
                                                         className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }